module.exports = __webpack_public_path__ + "static/media/bg11.23a77595.jpg";